import { snackbar } from "@mobiscroll/react5";
import { useEffect, useState } from "react";
import { getQuery, postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { CREATE_INVOICE_PDF } from "src/components/graphql/GraphQLmutation";
import { GET_INVOICE_DATA, INVOICE_PDF_DOWNLOAD_DATA, } from "src/components/graphql/GraphQLquery";

export default function useInvoicePdf(invoiceId) {
  // console.log(invoiceId);
  const [invoiceData, setInvoiceData] = useState(null);
  const [invoiceBase64, setInvoiceBase64] = useState(null);
  const [isInvoiceLoading, setLoading] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const clinicName = sessionStorage.getItem("clinicName");
  // const pdfURL = "https://hnusdzf9sh.execute-api.ap-south-1.amazonaws.com/dev/pdf/invoice";

  const getDate = date => {
    return new Date(date).toLocaleDateString([], { year: "numeric", month: "short", day: "numeric", })
  }

  const fetchPdfBase64 = async (data) => {
    try {
      const response = await postMutation(CREATE_INVOICE_PDF, data);

      if (response?.data?.createInvoicePdf?.base64) {
        setInvoiceBase64(`data:application/pdf;base64,${response?.data?.createInvoicePdf?.base64}`);
        setLoading(false);
        return `data:application/pdf;base64,${response?.data?.createInvoicePdf?.base64}`;
      } else {
        snackbar({ message: "Unable to prepare invoice Pdf", color: "danger", });
        console.log("response error", response);
      }

    } catch (error) {
      snackbar({ message: "Unable to prepare invoice Pdf", color: "danger", });
      console.error(error);
      return null;
    }
  };

  const fetchInvoiceData = async () => {
    if (invoiceId === null || invoiceId === undefined) {
      setLoading(false);
      return;
    }
    setLoading(true);
    snackbar({ message: "Please wait. Getting all the details..", color: "success", });

    const res = await getQuery(GET_INVOICE_DATA(invoiceId));

    if (!res.data?.getInvoice?.data) {
      setLoading(false);
      return null;
    }

    let itemData = res.data.getInvoice.data.items || [];
    let subTotal = 0;
    let tax = 0;
    let total = 0;
    let cgst = 0;
    let sgst = 0;
    itemData.forEach((item) => {
      subTotal += item.amount;
      tax += item.cgst + item.sgst;
      total = total + (subTotal + (subTotal * item.cgst) / 100 + (subTotal * item.sgst) / 100);
      cgst += item.cgst;
      sgst += item.sgst;
    });
    setSubTotal(subTotal);
    setTax(tax);
    setTotal(total);

    let clinicId = sessionStorage.getItem("clinic_id");

    const pdfRes = await getQuery(
      INVOICE_PDF_DOWNLOAD_DATA(
        res.data.getInvoice.data.appointmentId,
        res.data.getInvoice.data.doctorId,
        res.data.getInvoice.data.patientId,
        clinicId
      )
    );

    if (!pdfRes.data) {
      setLoading(false);
      return null;
    }
    const temaplateData = {
      invoice: res.data.getInvoice.data,
      appointmentData: pdfRes.data.getAppointment.data,
      doctorData: pdfRes.data.getDoctor.data,
      clinicData: pdfRes.data.getClinicProfile.data,
      patientData: pdfRes.data.getPatient.data,
    };

    setInvoiceData({ ...res.data.getInvoice.data, transactionId: pdfRes.data.getAppointment.data?.payment?.razorpayTransactionId || "" });

    const base64 = await fetchPdfBase64(temaplateData);
    if (base64) setInvoiceBase64(base64);

    setLoading(false);
    return base64 || null;
  };

  const downloadInvoice = async () => {
    // prevent double clicks
    // if (isInvoiceLoading) return;

    // let base64 = invoiceBase64;
    // if (!base64) {
    //   base64 = await fetchInvoiceData();
    // }

    if (invoiceBase64) {
      const link = document.createElement("a");
      const linkSource = invoiceBase64;
      const file_name = "Invoice_" + invoiceData?.to + getDate(invoiceData?.createdAt) + ".pdf";

      link.href = linkSource;
      link.download = file_name;
      link.click();
      link.remove();

      snackbar({ message: "Invoice Downloaded Successfully", color: "success", });
    } else {
      snackbar({ message: "Please Wait.. Loading..", color: "success", });
    }
  };

  return {
    downloadInvoice,
    isInvoiceLoading,
    invoiceData,
    subTotal,
    invoiceBase64,
    fetchInvoiceData,
    total,
    tax,
    invoiceFileName: clinicName + "_Invoice_" + invoiceData?.to + "_" + getDate(invoiceData?.createdAt) + ".pdf",
  };
}